<template>
  <div id="library"
  class="background">
      <Banner :tests="tests" :baseURL="baseURL"/>
      <Navigation/>
      <Resources :tests="tests" :baseURL="baseURL"/>
  </div>
</template>

<script>
import Banner from '@/components/tests/Banner';
import Resources from '@/components/tests/Resources';
import Navigation from '@/components/home/Navigation';

  export default {
    name: 'Library',

     components: {
        Banner,
        Navigation,
        Resources
    },

    data () {
      return {
        tab: null,
        tests: {
          "id": 1,
          "Test": [
            {
              "id": 3,
              "Title": "Home Insurance",
              "Description": "",
              "Answers": [
                {
                  "id": 1,
                  "Answer": "C - £1,000,000"
                },
                {
                  "id": 2,
                  "Answer": "C - £75,000"
                },
                {
                  "id": 3,
                  "Answer": "C - £100,000"
                },
                {
                  "id": 4,
                  "Answer": "A - 10% of contents sum insured"
                },
                {
                  "id": 5,
                  "Answer": "B - 180 days"
                },
                {
                  "id": 6,
                  "Answer": "B - False"
                },
                {
                  "id": 7,
                  "Answer": "B - 2 years"
                },
                {
                  "id": 8,
                  "Answer": "C - 9 years"
                },
                {
                  "id": 9,
                  "Answer": "B - Removing and replacing any part of the buildings to find and repair the source of any water or oil escaping from tanks, pipes, equipment or fixed heating system in the building"
                },
                {
                  "id": 10,
                  "Answer": "C - £10,000"
                },
                {
                  "id": 11,
                  "Answer": "B - £2,500"
                },
                {
                  "id": 12,
                  "Answer": "I - All of the above"
                },
                {
                  "id": 13,
                  "Answer": "C - £1,000 per claim and £100 for overnight accommodation including VAT"
                },
                {
                  "id": 14,
                  "Answer": "A - Septic tanks, guttering and down pipes"
                },
                {
                  "id": 15,
                  "Answer": "A - True"
                },
                {
                  "id": 16,
                  "Answer": "H - All of the above"
                },
                {
                  "id": 17,
                  "Answer": "C - £100,000"
                },
                {
                  "id": 18,
                  "Answer": "B - Arc Legal Assistance and Legal Insurance Management Ltd"
                },
                {
                  "id": 19,
                  "Answer": "A - On renewal of their cover"
                },
                {
                  "id": 20,
                  "Answer": "A - True"
                },
                {
                  "id": 21,
                  "Answer": "C - £250"
                },
                {
                  "id": 22,
                  "Answer": "A - True"
                },
                {
                  "id": 23,
                  "Answer": "C - Paint accidentally spilled on the carpet and E - General wear and tear"
                },
                {
                  "id": 24,
                  "Answer": "B - Accidental breakage of glass, ceramic hobs or sanitary fittings fixed to and forming part of your home"
                },
                {
                  "id": 25,
                  "Answer": "A - Accidental breakage of underground drains and pipes, C - Accidental damage to TVs, DVDs, computers, laptops, etc and E - Accidental spillages such as spilled wine or paint"
                },
                {
                  "id": 26,
                  "Answer": "E - All of the above"
                },
                {
                  "id": 27,
                  "Answer": "B - A document sent to the customer with their certificate and terms and conditions to inform them who is underwriting their policy"
                },
                {
                  "id": 28,
                  "Answer": "B - False"
                }
              ],
              "Thumbnail": {
                "id": 6,
                "name": "home_insurance_product_test.jpg",
                "alternativeText": "Home Insurance Product Test",
                "ext": ".jpg",
                "mime": "image/jpg",
                "size": 28.94,
                "url": "/assets/img/tests/home_insurance_product_test.jpg",
              },
              "File": {
                "id": 8,
                "name": "home_insurance_product_test.pdf",
                "ext": ".pdf",
                "mime": "application/pdf",
                "url": "https://info.paymentshield.co.uk/l/682253/2024-01-24/k8t9l/682253/1706110969rCTIFNMk/PSL_Home_Insurance_product_test_0224_24012024.pdf",
              }
            },
            {
              "id": 4,
              "Title": "Home Insurance exclusions",
              "Description": "",
              "Answers": [
                {
                  "id": 1,
                  "Answer": "A - True"
                },
                {
                  "id": 2,
                  "Answer": "E - All of the above"
                },
                {
                  "id": 3,
                  "Answer": "C - Both wet and dry rot"
                },
                {
                  "id": 4,
                  "Answer": "A - True"
                },
                {
                  "id": 5,
                  "Answer": "A - The buildings excess shown on the certificate of insurance and C Loss or damage occurring after the home has been left unoccupied"
                },
                {
                  "id": 6,
                  "Answer": "A - The buildings excess shown on the certificate of insurance, B - Loss or damage to fences, hedges and gates and E - Damage caused by a rise in the water table (the level below which the ground is completely saturated with water)"
                },
                {
                  "id": 7,
                  "Answer": "A - The buildings excess shown on the certificate of insurance and B - Loss or damage occurring after the home has been left unoccupied"
                },
                {
                  "id": 8,
                  "Answer": "A - True"
                },
                {
                  "id": 9,
                  "Answer": "D - All of the above"
                },
                {
                  "id": 10,
                  "Answer": "B - No"
                },
                {
                  "id": 11,
                  "Answer": "B - Mrs. Smith is covered for the cost of replacing the glass only"
                },
                {
                  "id": 12,
                  "Answer": "G - All of the above"
                },
                {
                  "id": 13,
                  "Answer": "F - All of the above"
                },
                {
                  "id": 14,
                  "Answer": "A - Dentures, D - Musical Instruments, E - Contact or corneal lenses, F - Camping equipment, G - Vehicles, watercraft and aircraft and J - Sports equipment while in use"
                },
                {
                  "id": 15,
                  "Answer": "A - Yes - providing the boiler has been maintained in line with manufacturer's recommendations"
                }
              ],
              "Thumbnail": {
                "id": 3,
                "name": "home_insurance_exclusion_test.jpg",
                "alternativeText": "Home Insurance Exclusion Test",
                "ext": ".jpg",
                "mime": "image/jpg",
                "size": 638.57,
                "url": "/assets/img/tests/home_insurance_exclusion_test.jpg",
              },
              "File": {
                "id": 3,
                "name": "home_insurance_exclusion_test.pdf",
                "ext": ".pdf",
                "mime": "application/pdf",
                "url": "https://info.paymentshield.co.uk/l/682253/2024-01-24/k8t9p/682253/1706110996NSTJldcU/PSL_Home_Insurance_exclusions_product_test_0225_24012024.pdf ",
              }
            },
            {
              "id": 5,
              "Title": "personal possessions",
              "Description": "",
              "Answers": [
                {
                  "id": 1,
                  "Answer": "C - £22,500 for Home Insurance and £30,000 for Contents Insurance Plus"
                },
                {
                  "id": 2,
                  "Answer": "C - Your client's chosen excess for contents"
                },
                {
                  "id": 3,
                  "Answer": "B - Widescreen television, D - Pets and livestock, E - Desktop computer, J - Drones and H - Software or downloaded information"
                },
                {
                  "id": 4,
                  "Answer": "A - True"
                },
                {
                  "id": 5,
                  "Answer": "A - True"
                },
                {
                  "id": 6,
                  "Answer": "C - £2,500"
                },
                {
                  "id": 7,
                  "Answer": "C - £2,500"
                },
                {
                  "id": 8,
                  "Answer": "B - £1,000"
                },
                {
                  "id": 9,
                  "Answer": "C - £500"
                },
                {
                  "id": 10,
                  "Answer": "A - Yes"
                },
                {
                  "id": 11,
                  "Answer": "A - True"
                },
                {
                  "id": 12,
                  "Answer": "C - £101,500"
                },
                {
                  "id": 13,
                  "Answer": "A - True"
                },
                {
                  "id": 14,
                  "Answer": "A - Yes"
                },
                {
                  "id": 15,
                  "Answer": "B - £22,500"
                },
                {
                  "id": 16,
                  "Answer": "C - £75,000"
                },
                {
                  "id": 17,
                  "Answer": "B - £2,500"
                },
                {
                  "id": 18,
                  "Answer": "C - Loss or damage caused by children under 3 years old"
                },
                {
                  "id": 19,
                  "Answer": "C - Ladies white gold ring, with plain purple sapphire stone, 15ct £3,000"
                }
              ],
              "Thumbnail": {
                "id": 3,
                "name": "personal_possessions_test.jpg",
                "alternativeText": "personal possessions Test",
                "ext": ".jpg",
                "mime": "image/jpg",
                "size": 638.57,
                "url": "/assets/img/tests/home_insurance_specifying_test.jpg",
              },
              "File": {
                "id": 3,
                "name": "personal_possessions_test.png",
                "ext": ".pdf",
                "mime": "application/pdf",
                "url": "https://info.paymentshield.co.uk/l/682253/2024-01-24/k8t9s/682253/1706111184jzIA3WkQ/PSL_personal_possessions_product_test_0226_24012024.pdf",
              }
            },
            {
              "id": 6,
              "Title": "accidental damage cover",
              "Description": "",
              "Answers": [
                {
                  "id": 1,
                  "Answer": "All the above"
                },
                {
                  "id": 2,
                  "Answer": "Visible damage which happens suddenly and has not been caused on purpose or inevitably"
                },
                {
                  "id": 3,
                  "Answer": "Up to the chosen content sum insured"
                },
                {
                  "id": 4,
                  "Answer": "Up to the chosen buildings sum insured"
                },
                {
                  "id": 5,
                  "Answer": "Up to £1,000"
                },
                {
                  "id": 6,
                  "Answer": "The clients chosen Buildings excess"
                },
                {
                  "id": 7,
                  "Answer": "False"
                },
                {
                  "id": 8,
                  "Answer": "The clients chosen contents excess"
                },
                {
                  "id": 9,
                  "Answer": "Yes"
                },
                {
                  "id": 10,
                  "Answer": "True"
                }
              ],
              "Thumbnail": {
                "id": 3,
                "name": "accidental_damage_product_test.jpg",
                "alternativeText": "Accidental Damage Product Test",
                "ext": ".jpg",
                "mime": "image/jpg",
                "url": "/assets/img/tests/accidental_damage_product_test.jpg",
              },
              "File": {
                "id": 3,
                "name": "accidental_damage_product_test.pdf",
                "ext": ".pdf",
                "mime": "application/pdf",
                "url": "https://info.paymentshieldadvisers.co.uk/l/682253/2021-10-08/7vqbg/682253/1633682518Euj5dzRw/PSL_Accidental_damage_Product_test_02141_07102021.pdf",
              }
            },
            {
              "id": 7,
              "Title": "home emergency",
              "Description": "",
              "Answers": [
                {
                  "id": 1,
                  "Answer": "£1,000"
                },
                {
                  "id": 2,
                  "Answer": "£100"
                },
                {
                  "id": 3,
                  "Answer": "Yes, as standard"
                },
                {
                  "id": 4,
                  "Answer": "True"
                },
                {
                  "id": 5,
                  "Answer": "All of the above"
                },
                {
                  "id": 6,
                  "Answer": "True"
                },
                {
                  "id": 7,
                  "Answer": "Arc Legal Assistance and Legal Insurance Management Ltd"
                },
                {
                  "id": 8,
                  "Answer": "No"
                },
                {
                  "id": 9,
                  "Answer": "£500"
                },
                {
                  "id": 10,
                  "Answer": "True"
                }
              ],
              "Thumbnail": {
                "id": 3,
                "name": "home_emergency_product_test.jpg",
                "alternativeText": "Home Emergency Product Test",
                "ext": ".jpg",
                "mime": "image/jpg",
                "url": "/assets/img/tests/home_emergency_product_test.jpg",
              },
              "File": {
                "id": 3,
                "name": "home_emergency_product_test.pdf",
                "ext": ".pdf",
                "mime": "application/pdf",
                "url": "https://info.paymentshieldadvisers.co.uk/l/682253/2021-10-08/7vqhx/682253/16336844575KUpvP3E/PSL_Home_Emergency_Product_test_02136_08102021.pdf",
              }
            },
            {
              "id": 8,
              "Title": "legal expenses",
              "Description": "",
              "Answers": [
                {
                  "id": 1,
                  "Answer": "£100,000"
                },
                {
                  "id": 2,
                  "Answer": "True"
                },
                {
                  "id": 3,
                  "Answer": "51% or greater"
                },
                {
                  "id": 4,
                  "Answer": "All of the above"
                },
                {
                  "id": 5,
                  "Answer": "£100 per day, up to a max £1,000"
                },
                {
                  "id": 6,
                  "Answer": "All of the above"
                },
                {
                  "id": 7,
                  "Answer": "True"
                },
                {
                  "id": 8,
                  "Answer": "UK & worldwide"
                },
                {
                  "id": 9,
                  "Answer": "UK only"
                },
                {
                  "id": 10,
                  "Answer": "Arc Legal Assistance and Legal Insurance Management Ltd"
                }
              ],
              "Thumbnail": {
                "id": 3,
                "name": "legal_expenses_product_test.jpg",
                "alternativeText": "Legal Expenses Product Test",
                "ext": ".jpg",
                "mime": "image/jpg",
                "url": "/assets/img/tests/legal_expenses_product_test.jpg",
              },
              "File": {
                "id": 3,
                "name": "legal_expenses_product_test.pdf",
                "ext": ".pdf",
                "mime": "application/pdf",
                "url": "https://info.paymentshieldadvisers.co.uk/l/682253/2021-10-08/7vqbj/682253/1633682582o9sAjwZR/PSL_Legal_Expenses_Product_test_02138_07102021.pdf",
              }
            },
            {
              "id": 9,
              "Title": "Landlords Insurance",
              "Description": "",
              "Answers": [
                {
                  "id": 1,
                  "Answer": "£1,000,000"
                },
                {
                  "id": 2,
                  "Answer": "£50,000"
                },
                {
                  "id": 3,
                  "Answer": "Accidental Damage to Buildings / Accidental Damage to Contents / Legal Expenses / Rent Protection / Landlords Emergency"
                },
                {
                  "id": 4,
                  "Answer": "Malicious damage by tenant"
                },
                {
                  "id": 5,
                  "Answer": "£200,000"
                },
                {
                  "id": 6,
                  "Answer": "Yes"
                },
                {
                  "id": 7,
                  "Answer": "£5,000"
                },
                {
                  "id": 8,
                  "Answer": "£2 million"
                },
                {
                  "id": 9,
                  "Answer": "Tenants funding rent through the benefits agency / Students"
                },
                {
                  "id": 10,
                  "Answer": "All of the above"
                },
                {
                  "id": 11,
                  "Answer": "£250"
                },
                {
                  "id": 12,
                  "Answer": "When the property is left unoccupied for between 45 and 90 days."
                },
                {
                  "id": 13,
                  "Answer": "All of the above"
                },
                {
                  "id": 14,
                  "Answer": "£100,000"
                },
                {
                  "id": 15,
                  "Answer": "Any actual or alleged abuse to your client or the tenant / Contracts of employment / Disputes over landslip, subsidence or heave"
                },
                {
                  "id": 16,
                  "Answer": "£1,000"
                },
                {
                  "id": 17,
                  "Answer": "False"
                },
                {
                  "id": 18,
                  "Answer": "£250"
                },
                {
                  "id": 19,
                  "Answer": "Boilers with an output of over 60kwph / Trace and access / Non-gas-powered systems / Underfloor heating"
                },
                {
                  "id": 20,
                  "Answer": "Up to £2,500 per month for 6 months"
                },
                {
                  "id": 21,
                  "Answer": "£100,000"
                }
              ],
              "Thumbnail": {
                "id": 3,
                "name": "PSL_Landlords_Insurance_Product_test.jpg",
                "alternativeText": "Landlords Insurance Product Test",
                "ext": ".jpg",
                "mime": "image/jpg",
                "url": "/assets/img/tests/landlords_insurance_product_test.jpg",
              },
              "File": {
                "id": 3,
                "name": "PSL_Landlords_Insurance_Product_test.pdf",
                "ext": ".pdf",
                "mime": "application/pdf",
                "url": "https://info.paymentshieldadvisers.co.uk/l/682253/2021-11-24/84ddz/682253/1637772607voW1wZtu/PSL_Landlords_Insurance_Product_test_02194_24112021.pdf",
              }
            },
            {
              "id": 9,
              "Title": "Tenants Contents",
              "Description": "",
              "Answers": [
                {
                  "id": 1,
                  "Answer": "£10,000"
                },
                {
                  "id": 2,
                  "Answer": "True"
                },
                {
                  "id": 3,
                  "Answer": "All of the above"
                },
                {
                  "id": 4,
                  "Answer": "£50,000"
                },
                {
                  "id": 5,
                  "Answer": "Yes"
                },
                {
                  "id": 6,
                  "Answer": "TVs"
                },
                {
                  "id": 7,
                  "Answer": "False (but they are covered under general contents cover)"
                },
                {
                  "id": 8,
                  "Answer": "True"
                }
              ],
              "Thumbnail": {
                "id": 3,
                "name": "tenants_contents_product_test.jpg",
                "alternativeText": "Tenants Contents Product Test",
                "ext": ".jpg",
                "mime": "image/jpg",
                "url": "/assets/img/tests/tenants_contents_product_test.jpg",
              },
              "File": {
                "id": 3,
                "name": "Tenants_Contents_Product_test.pdf",
                "ext": ".pdf",
                "mime": "application/pdf",
                "url": "https://info.paymentshieldadvisers.co.uk/l/682253/2022-02-02/8qdl5/682253/1643816136CTFOzZQU/PSL_Tenants_Contents_Product_Test_02227_01022022.pdf",
              }
            },
            {
              "id": 10,
              "Title": "Mortgage Protection",
              "Description": "",
              "Answers": [
                {
                  "id": 1,
                  "Answer": "Protect a monthly mortgage payment and associated costs if the policyholder should suffer an accident or sickness & unemployment"
                },
                {
                  "id": 2,
                  "Answer": "Accident & Sickness, Accident Sickness and Unemployment"
                },
                {
                  "id": 3,
                  "Answer": "12 months/24 months"
                },
                {
                  "id": 4,
                  "Answer": "They would receive 30 days payment on day 91"
                },
                {
                  "id": 5,
                  "Answer": "£3000/75% of income"
                },
                {
                  "id": 6,
                  "Answer": "True"
                },
                {
                  "id": 7,
                  "Answer": "No, they must be within 30 days of a brand-new mortgage or re-mortgage"
                },
                {
                  "id": 8,
                  "Answer": "Any condition, injury, illness, disease, sickness or related condition and/or associated symptoms, whether diagnosed or not which you knew about, or should reasonably have known about, at the start date, or which you had seen or arranged to see a doctor about, during the 12 months immediately before the start date"
                },
                {
                  "id": 9,
                  "Answer": "Age 65"
                },
                {
                  "id": 10,
                  "Answer": "£50,000"
                }
              ],
              "Thumbnail": {
                "id": 3,
                "name": "mppi_product_test.jpg",
                "alternativeText": "MPPI Product Test",
                "ext": ".jpg",
                "mime": "image/jpg",
                "url": "/assets/img/tests/mppi_product_test.jpg",
              },
              "File": {
                "id": 3,
                "name": "MPPI_Product_test.pdf",
                "ext": ".pdf",
                "mime": "application/pdf",
                "url": "https://info.paymentshield.co.uk/l/682253/2025-09-04/lvvc3/682253/17569786644tO1Ew6u/PSL_Mortgage_protection_Product_test_FPR2_2801_190825.pdf",
              }
            }
          ],
        "PageBanner": {
          "id": 4,
          "Title": "Test your knowledge",
          "Body": "<p>Find out just how much you know about our insurance with our in depth product tests.&nbsp;<br>Open and complete the test then check how you did by viewing the answers on screen.</p>",
          "Thumbnail": {
            "id": 7,
            "name": ".png",
            "alternativeText": "",
            "width": 185,
            "height": 185,
            "ext": ".png",
            "mime": "image/png",
            "size": 41.54,
            "url": "/assets/img/balls/tests.png",
          }
        }
      },
        baseURL: '',
      }
    },
    mounted(){
        window.dataLayer.push({
            'event':'virtualPageView',
            'virtualPageURL':'/vpv/tests',
            'virtualPageTitle' : 'Tests | GI Academy'
        }); 
    }
  }

  // window.dataLayer.push({
  //   'event':'virtualPageView',
  //   'virtualPageURL':'/vpv/tests',
  //   'virtualPageTitle' : 'Tests | GI Academy'
  // }); 
</script>
